export const API_URL: any = (window as any).urls;
// Serveur Central VPS (Utilisé UNIQUEMENT pour la vérification / validation des 10 billets fidélité)
export const VPS_URL: any = (window as any).vpsUrl || 'http://169.58.185.13:8800';
// export const VPS_URL: any = 'http://192.168.100.193:8800'; // Pour test local si nécessaire
// export const API_URL = 'http://192.168.137.43:8880';
// export const API_URL = 'http://192.168.100.51:8888';
export const API_DOMAIN = 'localhost';
export const API_DOMAIN_SIGNATURE = 'http://localhost:7777';

// Constants for file types
export const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
export const EXCEL_EXTENSION = '.xlsx';

// export const API_URL = 'http://192.168.74.89';
// export const API_DOMAIN = '192.168.74.89';

// export const API_URL = 'https://api-dev.ghssvlis.com';
// export const API_DOMAIN = 'api-dev.ghssvlis.com';
